import { FC } from 'react';
import { LAST_ACTIVE_PLACEHOLDER, lastActiveOf, LastActiveUnit } from 'shared';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { StringKey } from '../../../../lang/index';

const MESSAGE_BY_UNIT: Record<LastActiveUnit, StringKey> = {
  [LastActiveUnit.DAYS]: 'LAST_ACTIVE_DAYS_AGO',
  [LastActiveUnit.HOURS]: 'LAST_ACTIVE_HOURS_AGO',
  [LastActiveUnit.JUST_NOW]: 'LAST_ACTIVE_JUST_NOW',
  [LastActiveUnit.MINUTES]: 'LAST_ACTIVE_MINUTES_AGO',
};

// Every "when" the data room and the workspaces show — last active, last edit, last updated.
export const LastActive: FC<{ at: Date | null | string | undefined }> = ({ at }) => {
  const lastActive = lastActiveOf(at);

  if (!lastActive) {
    return LAST_ACTIVE_PLACEHOLDER;
  }

  if ('date' in lastActive) {
    return lastActive.date;
  }

  return (
    <AppFormattedMessage
      id={MESSAGE_BY_UNIT[lastActive.unit]}
      values={{ count: lastActive.count }}
    />
  );
};
